import React, { FC, useEffect, useRef, useState } from 'react';
import { useMutation } from 'react-relay';
import { TimeOnPlatformCreateMutation } from '../../graphQLOperations/__generated__/TimeOnPlatformCreateMutation.graphql';
import { createTimeSession, updateTimeSession } from '../../graphQLOperations/TimeOnPlatform';
import { TimeOnPlatformUpdateMutation } from '../../graphQLOperations/__generated__/TimeOnPlatformUpdateMutation.graphql';
import { useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/reducers/userSlice';
import { Roles } from '../../models/User';

export const TimeOnPlatformTracker: FC<React.PropsWithChildren> = ({ children }) => {
  const [createTimeSessionOnPlatform] = useMutation<TimeOnPlatformCreateMutation>(createTimeSession);
  const [updateTimeSessionOnPlatform] = useMutation<TimeOnPlatformUpdateMutation>(updateTimeSession);
  const timeOutRef = useRef<NodeJS.Timeout | null>(null);
  const [lastTimeSession, setLastTimeSession] = useState<string | null>(null);
  const [refetchSessionTime, setRefetchSessionTime] = useState(0);
  const userRedux = useAppSelector(selectUser);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (timeOutRef.current) {
        clearTimeout(timeOutRef.current);
      }
      if (document.visibilityState === 'visible') {
        setRefetchSessionTime(new Date().getTime());
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  const updateTimeOnPlatformSessionRepeat = (id: string) => {
    timeOutRef.current = setTimeout(() => {
      if (document.visibilityState === 'visible') {
        updateTimeSessionOnPlatform({
          variables: {
            input: {
              userPlatformSessionId: id,
            },
          },
          onCompleted: data => {
            if (data.updateUserPlatformSessionLastPing.userPlatformSessionNode?.id) {
              updateTimeOnPlatformSessionRepeat(id);
            } else {
              setLastTimeSession(null);
              setRefetchSessionTime(new Date().getTime());
            }
          },
        });
      }
    }, 60000);
  };

  useEffect(() => {
    if (userRedux?.roles.some(role => role.name === Roles.STUDENT) && document.visibilityState === 'visible') {
      if (lastTimeSession) {
        updateTimeSessionOnPlatform({
          variables: {
            input: { userPlatformSessionId: lastTimeSession },
          },
          onCompleted: data => {
            if (data.updateUserPlatformSessionLastPing.userPlatformSessionNode?.id) {
              updateTimeOnPlatformSessionRepeat(lastTimeSession);
            } else {
              setLastTimeSession(null);
              setRefetchSessionTime(new Date().getTime());
            }
          },
        });
      } else {
        createTimeSessionOnPlatform({
          variables: {},
          onCompleted: data => {
            setLastTimeSession(data.createUserPlatformSession.userPlatformSessionNode?.id || null);
            updateTimeOnPlatformSessionRepeat(data.createUserPlatformSession.userPlatformSessionNode?.id || '');
          },
        });
      }
    }
  }, [refetchSessionTime]);

  return <>{children}</>;
};
